import * as React from 'react';
export const filterSvg = React.forwardRef(function filterSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 9 .9 3.533a2 2 0 0 1-.4-1.2V2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v.333a2 2 0 0 1-.4 1.2L11 9v2.93a2 2 0 0 1-.89 1.664l-3.358 2.238a1 1 0 0 1-.555.168H5.5a.5.5 0 0 1-.5-.5V9ZM2.5 1.5h11a.5.5 0 0 1 .5.5c0 .213.036.452-.1.633L10.25 7.5h-4.5L2.1 2.633C1.964 2.452 2 2.213 2 2a.5.5 0 0 1 .5-.5Zm7 7.5h-3v5.197l2.777-1.851a.5.5 0 0 0 .223-.416V9Z',
    }),
  );
});
filterSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var filter = {
  category: 'icon',
  colorable: true,
  name: 'filter',
  svg: filterSvg,
};
